export const CLEAR_SEARCH_TERM = "UI/MY_ANIMATIONS/CLEAR_SEARCH_TERM";
export const ANIMATION_SEARCH_REQUEST =
  "UI/MY_ANIMATIONS/ANIMATION_SEARCH_REQUEST";
